export default "__VITE_ASSET__gYeTNvgY__"